import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'Replace'})
export class ReplacePipe implements PipeTransform{
    transform(value:string,from:string,to:string){
        return value.replace(from,to);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/replace.pipe.ts